import { countryCodeOptions } from '@microsoft/portal-app/lib/PhoneFields/PhoneField/phoneCountryCodes';
import { settingsManager } from '../shared/settings';

export function parsePhone(phone: string): [string, string] {
  phone = normalizePhone(phone);
  const countryCode = countryCodeOptions.find(o => phone.startsWith(o.key))?.key;
  const phoneNumber = countryCode != null ? phone.slice(countryCode.length) : phone;

  return [countryCode ?? '1', phoneNumber];
}

export function normalizePhone(phone: string): string {
  return phone.replace(/[()\s+-]/g, '');
}

/**
 * Returns true if contact preference is supported in the current environment.
 */
export function isContactPreferenceSupported(): boolean {
  const cpmAudience = settingsManager.get('cpmAudience');
  const cpmBaseUrl = settingsManager.get('cpmBaseUrl');
  const msGraphBaseUrl = settingsManager.getRequired('msGraphResourceName');

  return !!cpmAudience && !!cpmBaseUrl && !!msGraphBaseUrl;
}
